import { useEffect, useState } from 'react';

const useLocalStorageValues = () => {
  if (typeof window !== 'undefined') {
    const [rfsn, setRfsn] = useState(localStorage.getItem('rfsn') || '');
    const [referrer, setReferrer] = useState(localStorage.getItem('referrer') || '');
    const [firstPageVisited, setFirstPageVisited] = useState(
      localStorage.getItem('first_page_visited') || ''
    );

    // Use useEffect to update state when localStorage changes
    useEffect(() => {
      const storedRfsn = localStorage.getItem('rfsn');
      const storedReferrer = localStorage.getItem('referrer');
      const storedFirstPageVisited = localStorage.getItem('first_page_visited');

      if (storedRfsn !== rfsn) {
        setRfsn(storedRfsn);
      }

      if (storedReferrer !== referrer) {
        setReferrer(storedReferrer);
      }

      if (storedFirstPageVisited !== firstPageVisited) {
        setFirstPageVisited(firstPageVisited);
      }
    }, [rfsn, referrer, firstPageVisited]);

    return { rfsn, referrer, firstPageVisited };
  } else return { rfsn: '', referrer: '', firstPageVisited: '' };
};

export default useLocalStorageValues;
